import { CalendarDate } from '@internationalized/date';

export const isAfterCutoff = (
  cutoff: CalendarDate,
  date: CalendarDate | null
) => date !== null && cutoff.compare(date) < 0;
